export enum MODIFIER_GROUP_REQUEST_ID_LIST {
  GET_MODIFIER_GROUPS = 'GET_MODIFIER_GROUPS',
  GET_ALL_MODIFIER_GROUPS = 'GET_ALL_MODIFIER_GROUPS',
  DELETE_MODIFIER_GROUP = 'DELETE_MODIFIER_GROUP',
  UPDATE_MODIFIER_GROUP_SEQUENCE = 'UPDATE_MODIFIER_GROUP_SEQUENCE',
  CREATE_MODIFIER_GROUP = 'CREATE_MODIFIER_GROUP',
  UPDATE_MODIFIER_GROUP = 'UPDATE_MODIFIER_GROUP',
}
